import React, { useState, useEffect } from 'react'
import { ImageIcon, DownloadIcon, PencilSolidIcon, TrashSolidIcon, Modal } from '../'
import { SimpleFetch, encodeMedia, store } from '../../_helpers'
import styles from './style.module.scss'

export const MediaImage = ({title, description, image, type, onChange}) => {
  if ( !title )
    throw("Can't render AddImage component without title")

  const [ domainData, setDomainData ] = useState()
  const [ modal, setModal ] = useState(false)
  const [ images, setImages ] = useState([])

  const getImages = async () => {
    const domain = store.getState().changeDomainReducer.selectedDomain

    const req = await SimpleFetch('GET', {}, {}, 'momentum', `gallery/list/${domain.domain_uuid}/domain`)
    if ( req.status !== 200 ) return
  
    setImages(req.data)
  }

  const handleUpload = async ({target}) => {
    const domain = store.getState().changeDomainReducer.selectedDomain

    const mediaUpload = [await encodeMedia(target.files[0])]

    const req = await SimpleFetch('POST', {}, {images: mediaUpload}, 'momentum', `gallery/upload/${domain.domain_uuid}/domain`)
    if ( req.status !== 200 ) return

    const url = `https://storage.googleapis.com/cellit/Person_${domain.domain_gero_id}%2F${req.data[0].name}?alt=media`
    onChange({value: url}, type);
  }

  return(<>
    <div className={styles.media}>
      {
        image ?
          <div className={styles["image__uploaded"]} style={{backgroundImage: `url(${image})`}}></div>
        : <div className={styles["image__wrapper"]}>
            <ImageIcon />
          </div>
      }
      <div className={styles["content__wrapper"]}>
        <p className={styles["title"]}>{title}</p>
        <p className={styles["description"]}>{description}</p>

        <div className="flex">
          <div className={styles["buttons__wrapper"]}>
            <label htmlFor={`notification_image_${type}`}>
              <DownloadIcon />
              Fazer upload
            </label>
            <input type="file" name="notification_image" id={`notification_image_${type}`} onChange={handleUpload} />
          </div>
          <div className={styles["buttons__wrapper"]}>
            <label onClick={() => {
              setModal(!modal);
              getImages();
            }}>
              <ImageIcon size="small"/>
              Escolher da biblioteca
            </label>
          </div>
        </div>
      </div>
    </div>

    <Modal
      title={{
        text: "Biblioteca de imagens",
        icon: "ImageIcon"
      }}
      active={{
        status: modal,
        onChange: setModal
      }}
      width="630px"
    >
      <div className={styles['images']}>
        {
          images ?
            images.map(({id, image}) => {
              return <div
                key={id}
                className={styles['image__block']}
                data-image={id}
                style={{backgroundImage: `url("${image}")`}}
                onClick={() => {setModal(false); onChange({id, value: image}, type)}}
              >
                <div className={styles['buttons__group']}>SELECIONAR</div>
              </div>
            })
          : null
        }
      </div>
    </Modal>
  </>)
}